(function ($) {
    "use strict";
    $(function () {

        if ($('.js-is-sasad-archive').length) {
            function findObjectByKey(array, key, value) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        return array[i];
                    }
                }
                return null;
            };
            if($('.js-sasad-childs').length) {
                $('.js-sasad-childs').each(function() {
                    const $this = $(this);
                    var residentialId = $(this).data('projectid');
                    var current_page_id = $(this).data('id');
                    var current_project = findObjectByKey(Object.values(localize.residentials), "id", current_page_id);
                    
                    if (residentialId) {
                        cordiaAPI
                            .get("/sf/getresidentialflatcount", {
                                params: {
                                    lang: $.langCookie,
                                },
                            })
                            .then(function (response) {

                                const flatCount = response.data[residentialId];
        
                                let sum = 0;
        
                                for (const prop in flatCount) {
                                    if (prop != current_project.sp_id && current_project.is_child) {
                                        continue;
                                    }
                                    sum += parseInt(flatCount[prop]);
                                }
        
                                $this.find(".js-all-flats-sasad-child").text(sum);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }


                    
                });
            }
        }

         /* Marina city project cards all flat numbers */
         if($(".js-all-flats-card").length && $(".project__card_content__flats").length) {
            function findObjectByKey(array, key, value) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        return array[i];
                    }
                }
                return null;
            };

            $(".project__card_content__flats").each(function() {
                
                    const $this = $(this);
                    var residentialId = $(this).data('project');
                    var current_page_id = $(this).data('id');
                    var current_project = findObjectByKey(Object.values(localize.residentials), "id", current_page_id);

                    
                    if (residentialId) {
                        cordiaAPI
                            .get("/sf/getresidentialflatcount", {
                                params: {
                                    lang: $.langCookie,
                                },
                            })
                            .then(function (response) {

                                const flatCount = response.data[residentialId];

                                if(flatCount) {
                                    $this.find(".js-all-flats-card").text(flatCount[current_project.sp_id]);
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }

            });
        }
    });
})(jQuery);
